import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  hideArrow = false,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content> & {
  hideArrow?: boolean;
}) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
              "aero:bg-brand-primary aero:text-brand-primary-foreground aero:animate-in aero:fade-in-0 aero:zoom-in-95 aero:data-[state=closed]:animate-out aero:data-[state=closed]:fade-out-0 aero:data-[side=bottom]:slide-in-from-top-2 aero:data-[side=left]:slide-in-from-right-2 aero:data-[side=right]:slide-in-from-left-2 aero:data-[side=top]:slide-in-from-bottom-2 aero:z-1300 aero:w-fit aero:origin-(--radix-tooltip-content-transform-origin) aero:rounded-md! aero:px-3 aero:py-1.5 aero:text-xs aero:text-balance",
          className
        )}
        {...props}
      >
        {children}
        {!hideArrow && (
            <TooltipPrimitive.Arrow className="aero:bg-brand-primary aero:fill-brand-primary aero:z-1300 aero:size-2.5 aero:translate-y-[calc(-50%-2px)] aero:rotate-45 aero:rounded-[2px]!" />
        )}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
